import BASE_URL from '../../utils/storage.js';

export const authAPI = {
  async login(phone_number, password, role) {
    const response = await fetch(`${BASE_URL}auth/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone_number, password, role }),
    });

    if (!response.ok) {
      let errorPayload = null;

      try {
        errorPayload = await response.json();
      } catch (parseError) {
        // Ignore parsing issues; we'll fall back to generic messaging
      }

      const error = new Error();

      if (response.status === 401) {
        error.code = 'INVALID_CREDENTIALS';
        error.message = 'Nu am găsit un cont cu aceste date. Verifică numărul de telefon și parola.';
      } else if (response.status >= 500) {
        error.code = 'SERVER_UNAVAILABLE';
        error.message = 'Serverul nu răspunde în acest moment. Te rugăm să încerci din nou mai târziu.';
      } else {
        error.code = 'AUTH_REQUEST_FAILED';
        error.message = errorPayload?.detail
          || 'Nu am reușit să te autentificăm. Verifică datele introduse și încearcă din nou.';
      }

      throw error;
    }

    const data = await response.json();
    
    if (!data.token) {
      const error = new Error('Răspuns neașteptat de la server. Te rugăm să încerci din nou.');
      error.code = 'INVALID_AUTH_RESPONSE';
      throw error;
    }

    return data;
  },

  async logout(authToken) {
    try {
      await fetch(`${BASE_URL}auth/logout/`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Token ${authToken}`
        },
      });
    } catch (error) {
      // Don't throw here as we want to clear local state regardless
    }
  },

  async register(userData) {
    const response = await fetch(`${BASE_URL}auth/users/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Registration failed');
    }

    return await response.json();
  },

  async requestPasswordReset(email) {
    const response = await fetch(`${BASE_URL}auth/users/reset_password/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('Password reset request failed');
    }

    return true;
  }
};
